import { gql } from '@apollo/client';

export * from './updateCustomIntegration.mutation.generated';

export const CREATE_CUSTOM_INTEGRATION = gql`
  mutation updateCustomIntegration(
    $customIntegrationInput: CustomIntegrationUpdateInputAttributes!
    $integrationId: ID!
  ) {
    updateCustomIntegration(input: { customIntegrationInput: $customIntegrationInput, integrationId: $integrationId }) {
      success
      errors
      customIntegration {
        accountName
        accountUrl
        active
        id
        provider
        status
      }
    }
  }
`;
